var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trend',{attrs:{"data":_vm.generateValues,"gradientDirection":"top","gradient":['#679973', '#A6E6B3'],"padding":8,"radius":8,"stroke-width":3,"stroke-linecap":"butt","auto-draw":"","smooth":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }